import {TEMPLATE} from './types';

export const SLIDE_TEMPLATE_OPTIONS = [
    {
        template: TEMPLATE.BLANK,
        labelKey: 'presEditPage.subNavBar.slide.blank',
        icon: 'solar:stop-linear',
    },
    {
        template: TEMPLATE.TITLE_SUBTITLE,
        labelKey: 'presEditPage.subNavBar.slide.titleSubtitle',
        icon: 'solar:align-left-linear',
    },
    {
        template: TEMPLATE.IMAGE,
        labelKey: 'presEditPage.subNavBar.slide.image',
        icon: 'solar:gallery-minimalistic-linear',
    },
    {
        template: TEMPLATE.TITLE_TEXT_IMAGE,
        labelKey: 'presEditPage.subNavBar.slide.titleTextImage',
        icon: 'solar:widget-4-linear',
    },
    {
        template: TEMPLATE.HTML_COVER,
        labelKey: 'presEditPage.subNavBar.slide.html',
        icon: 'solar:code-linear',
    },
] as const;

export type SlideTemplateOption = (typeof SLIDE_TEMPLATE_OPTIONS)[number];

/** Layout templates for applying content to an already-empty slide (excludes blank). */
export const SLIDE_LAYOUT_TEMPLATE_OPTIONS = SLIDE_TEMPLATE_OPTIONS.filter(
    (option): option is Exclude<SlideTemplateOption, {template: TEMPLATE.BLANK}> => option.template !== TEMPLATE.BLANK
);
